import type { CSSProperties, ReactNode } from 'react';
import { cn } from '../../lib/utils';

export interface CellMonoProps {
  value: ReactNode;
  color?: string;
  right?: boolean;
  bold?: boolean;
  className?: string;
}

function isHexColor(value: string): boolean {
  return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(value);
}

export function CellMono({
  value,
  color,
  right,
  bold,
  className,
}: CellMonoProps) {
  const inlineStyle: CSSProperties | undefined =
    color && isHexColor(color) ? { color } : undefined;
  const colorClass = color && !isHexColor(color) ? color : undefined;
  return (
    <div
      style={inlineStyle}
      className={cn(
        'font-mono text-[11px] tabular-nums',
        right ? 'text-right' : 'text-left',
        bold ? 'font-bold' : 'font-medium',
        colorClass,
        className
      )}
    >
      {value}
    </div>
  );
}

CellMono.displayName = 'CellMono';

export default CellMono;
